var phoneStyles = {
  "phoneField": {
    "display": "flex"
  },
  "phoneField_focus____flag": {
    "borderColor": "#006fcf"
  },
  "phoneField_focus_all_children__select_select": {
    "borderColor": "#006fcf"
  },
  "phoneField_hasWarning____flag": {
    "borderColor": "#b42c01"
  },
  "phoneField_hasWarning_all_children__select_select": {
    "borderColor": "#b42c01"
  },
  "phoneField__phoneSide": {
    "display": "inline-block",
    "borderRadius": "0.25rem 0 0 0.25rem",
    "borderRight": "none !important",
    "marginTop": "0.3125rem",
    "backgroundColor": "#fff"
  },
  "phoneField__countries__select": {
    "display": "inline-block",
    "borderRadius": "0.25rem 0 0 0.25rem",
    "borderRight": "none !important",
    "marginTop": "0.3125rem",
    "backgroundColor": "#fff",
    "width": "4.875rem",
    "height": "3.125rem",
    "padding": "0"
  },
  "phoneField__flag": {
    "display": "inline-block",
    "borderRadius": "0.25rem 0 0 0.25rem",
    "borderRight": "none !important",
    "marginTop": "0.3125rem",
    "backgroundColor": "#fff",
    "padding": "0.75rem 0.938rem",
    "border": "0.0625rem solid #c8c9c7"
  },
  "phoneField__flag_span": {
    "width": "2rem",
    "height": "1.375rem",
    "verticalAlign": "middle"
  },
  "phoneField__countries": {
    "position": "relative"
  },
  "phoneField__countries__select_select": {
    "position": "absolute",
    "paddingTop": "3rem",
    "paddingBottom": "0",
    "height": "3rem",
    "overflow": "hidden",
    "width": "100%",
    "zIndex": "2",
    "borderBottomRightRadius": "0",
    "borderTopRightRadius": "0",
    "borderRight": "none !important",
    "&:active": {
      "outlineOffset": "-0.375rem !important"
    },
    "&:focus": {
      "outlineOffset": "-0.375rem !important"
    }
  },
  "phoneField__countries__prefix": {
    "position": "absolute",
    "top": "1.25rem",
    "bottom": "1.25rem",
    "left": "0.625rem",
    "width": "2.5rem",
    "textAlign": "center"
  },
  "phoneField__phone": {
    "marginTop": "0.3125rem",
    "display": "inline-block",
    "position": "relative !important",
    "width": "100%"
  },
  "phoneField__phone_input": {
    "&:not(:last-child)": {
      "borderBottomLeftRadius": "0",
      "borderTopLeftRadius": "0"
    }
  },
  "phoneField__phone__prefix": {
    "position": "absolute",
    "height": "100%",
    "padding": "0.625rem",
    "display": "flex",
    "alignItems": "center",
    "top": "0",
    "bottom": "0",
    "left": "0",
    "fontSize": "1rem"
  }
};

export default phoneStyles;
